/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';
export var livePlans = makeEntityScaffold('SAGA.API.LIVE_PLANS', function (client) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return client.plans.getLive(options).then(function (res) {
    return res.data;
  });
});
export var livePlansByMsa = makeEntityScaffold('SAGA.API.LIVE_PLANS_BY_MSA', function (client, msaId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.plans.getLiveByMsa(msaId, options).then(function (res) {
    return res.data;
  });
}, {
  defaultKey: 1
});
export var livePlanById = makeEntityScaffold('SAGA.API.LIVE_PLAN_BY_ID', function (client, planId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.plans.getLiveById(planId, options).then(function (res) {
    return res.data;
  });
}, {
  defaultKey: 1
});
export var plansByMsa = makeEntityScaffold('SAGA.API.PLANS', function (client, msaId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.plans.getByMsaV3(msaId, options).then(function (data) {
    return data.plans;
  });
}, {
  defaultKey: 1
});
export var planById = makeEntityScaffold('SAGA.API.PLAN_BY_ID', function (client, planId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.plans.getByIdV2(planId, options);
}, {
  defaultKey: 1
});
export var saveOffer = makeEntityScaffold('SAGA.API.SAVE_OFFER', function (client, userId) {
  return client.plans.getUserSaveOffer(userId);
});